/* global _ */

import api from './api';

const { noop } = _;

export default function( request, callback ) {
	callback = callback || noop;

	api( 'innoway/v2/set_rating', request, response => {
		callback( response );
	}, 'POST' );
}
